// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MODAL CONTAINER */

.fragen-background {
    position: fixed;
    top: 80px;
    left: 0;
    align-self: center;
    width: 100%;
    height: calc(100% - 80px);
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
}

.fragen-content-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-self: center;
    width: 80%;
    height: 95%;
    background-color: var(--white-base);
    border-radius: 20px;
}

.fragen-closebutton {
    position: absolute;
    cursor: pointer;
    top: 10px;
    right: 10px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
}

.fragen-header-container {
    position: relative;
    margin: 30px 50px 20px 10px;
    align-self: center;

    /* TEXT STYLE */
    font-family: Poppins;
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
}

.fragen-header-gruppenassessment {
    color: var(--vzk-blue);
    font-size: 18px;
    font-weight: 600;
}

.fragen-main-content-split {
    position: relative;
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.fragen-main-content {
    position: relative;
    display: flex;
    margin: 10px;
    height: 100%;
    width: 97%;
    justify-content: center;
    align-self: center;
    align-items: center;
}

.fragen-main-inner-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
}


.fragen-page-container {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    margin: 10px;
    gap: 20px;
}


.fragen-page-title {
    position: relative;


    /* TEXT STYLE */
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
}


.fragen-page-end-title {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;


    /* TEXT STYLE */
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
}

.fragen-page-img {
    display: flex;
    justify-content: top;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}

.fragen-page-disclaimer {
    color: var(--blue-grey-500);

    font-family: Poppins;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
}

.fragen-page-img img {
    max-width: 60%;
    height: auto;
}

.fragen-page-button-container {
    position: relative;
    top: 100%;
    bottom: 0px;
    display: flex;
    width: 100%;
    flex-direction: row;
}


@media (max-height: 3000px) {
    .fragen-page-button-container {
      top: 10%;
    }
  }


.fragen-end-container {
    margin-top: 50px;
    margin-right: 20px;
    gap: 50px;
}

.fragen-page-button {
    position: relative;
    display: flex;
    justify-content: center;
    align-self: center;
    margin-left: auto;
    margin-right: auto;
    cursor: pointer;
    border-radius: 20px;
    padding: 0px 15px;
    -webkit-user-select: none;
            user-select: none;
    background-color: var(--border);

    /* TEXT STYLE */
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
}




/* MODAL CONTAINER END */


/* FRAGE CONTAINER */

.frage-title-header-container {
    margin: 10px 40px;
    overflow-y: auto;
}

.frage-title-container {
    position: relative;
    height: fit-content;
}

.frage-title-header {
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
}

.frage-container {
    position: relative;
    display: flex;
    flex-direction: column;
    width: fit-content;
    height: fit-content;
    min-height: 80px;


    /* TEXT STYLE */
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%;
}

.frage-beispiel {
    color: var(--blue-grey-500);
    /* Body */
    font-family: Poppins;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
}

.frage-kategorie {
    color: var(--vzk-blue);
    /* Body */
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
}

.antwort-container {
    position: relative;
    display: flex;
    flex-direction: column;
    margin-top: 0px;
    margin-bottom: 0px;
    gap: 0px;
}

.antonwort-item-container {
    position: relative;
    display: flex;
    min-height: 75px;
    height: fit-content;
    /*84px;*/
    overflow-y: auto;
    padding: 10px;
    align-items: flex-start;
    flex-direction: column;
    align-items: top;
}

.antonwort-item-beispiel {
    position: relative;
    margin-top: auto;
    margin-left: 50px;
    margin-bottom: 0px;
    text-align: left;
    /* Changed to left alignment */
    color: var(--gray-50);

    /* TEXT STYLE */
    font-family: Poppins;
    font-size: 14px;
    font-style: italic;
    font-weight: 400;
}

.antwort-level {
    margin-left: 10px;
    -webkit-user-select: none;
            user-select: none;

    /* TEXT STYLE */
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
}


/* Styles for the radio buttons */
.antonwort-item-container input[type="radio"] {
    display: none;
    /* Hide the actual radio button */
}

/* Styles for the custom radio button appearance */
.antonwort-item-container input[type="radio"]+label {
    position: relative;
    display: inline-block;
    padding-left: 25px;
    /* Adjust spacing between the custom radio button and label if needed */
    padding-right: 8px;
    /* Adjust the space between the custom radio button and label text */
    cursor: pointer;
}

/* Styles for the custom radio button when not checked */
.antonwort-item-container input[type="radio"]+label:before {
    content: "";
    position: absolute;
    top: 30%;
    left: 0;
    width: 16px;
    height: 16px;
    border: 2px solid var(--border);
    border-radius: 3px;
    background-color: #fff;
    transform: translateX(-10px);
}

/* Styles for the custom radio button when checked */
.antonwort-item-container input[type="radio"]:checked+label:before {
    background-color: var(--blue-60);
    border: none;
    box-shadow: 0 0 0 2px #fff, 0 0 0 4px var(--blue-60);
    transform: translateX(-10px);
}

/* FRAGE CONTAINER END */



/* FOOTER CONTAINER */

.footer-container {
    position: relative;
    display: flex;
    flex-direction: column;
}

.footer-item-container {
    position: relative;
    display: flex;
    flex-direction: row;
    border-radius: 0px 0px 18px 18px;
    background-color: var(--gray-40);
    min-height: 50px;
}

.footer-item {
    position: relative;
    display: flex;
    justify-content: center;
    align-self: center;
    margin-left: auto;
    margin-right: auto;
    cursor: pointer;
    border-radius: 20px;
    background-color: var(--white-base);
    padding: 0px 15px;
    -webkit-user-select: none;
            user-select: none;

    /* TEXT STYLE */
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
}

.item-left {
    margin: 0px 10px 0px auto;
    border-radius: 20px 5px 5px 20px;
}


.item-pause {
    margin: 0px 0px;
    border-radius: 5px;
}


.item-right {
    margin: 0px auto 0px 10px;
    border-radius: 5px 20px 20px 5px;
}

.item-comment-aktive {
    margin: 0px 10px 0px auto;
    border-radius: 20px 20px 0px 20px;
}

.item-comment-disabled {
    background-color: var(--gray-50);
    color: var(--gray-20);
    margin: 0px 10px 0px auto;
    border-radius: 20px 20px 0px 20px;
    pointer-events: none;
}

.item-help {
    margin: 0px auto 0px 10px;
}

.item-bezugsdatum-festlegen {
    border: none;
    margin: 0px;
}

.item-save {
    margin: 0px auto 0px auto;
}

.footer-item-text {
    position: relative;
    display: flex;
    align-self: center;
    margin-left: auto;
    margin-right: 10px;
    -webkit-user-select: none;
            user-select: none;

    /* TEXT STYLE */
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
}

.button-disabled{    
    background-color: var(--gray-50);
    color: var(--gray-20);
    pointer-events: none;
}

/* FOOTER CONTAINER END */



/* COMMENT CONTAINER */

.comment-container {
    position: fixed;
    width: 100%;
    max-width: 70%;
    /* Adjust the value based on your margin for .frage-title-header-container */
    height: 16%;
    bottom: 60px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
    z-index: 2;
    /* Ensure the Kommentar widget appears above other elements */
    opacity: 0;
    animation: fadeIn 0.5s forwards;
    /* Apply fadeIn animation when initially rendered */
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateX(-50%), translateY(20px);
        /* Adjust the starting position */
    }

    to {
        opacity: 1;
        transform: translateX(-50%), translateY(0);
    }
}

.comment-closebutton {
    position: absolute;
    z-index: 99;
    top: 10px;
    right: 10px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    cursor: pointer;
}

.comment-title {
    position: relative;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
}

.comment-content {
    position: relative;
    width: 100%;
    height: 100%;
    max-height: 60%;
    /* Set max-height to 100% of the parent container */
    box-sizing: border-box;
    /* Include padding and borders in the height and width calculations */
}

.comment-textarea {
    position: relative;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 100%;
    height: 70%;
    max-width: 100%;
    max-height: 90%;

    font-size: 16px;
    line-height: 1.5;
}

.comment-button-section {
    position: relative;
    display: flex;
    flex-direction: row;
    height: fit-content;
    height: 30%;

    /* TEXT STYLE */
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    line-height: 150%;
    color: white;
}

.commen-button-l {
    position: relative;
    height: fit-content;
    width: fit-content;
    cursor: pointer;
    padding: 5px 20px;
    margin: 0px auto 0px 0px;
    border-radius: 5px;
    background-color: var(--blue-60);
}

.commen-button-r {
    position: relative;
    height: fit-content;
    width: fit-content;
    cursor: pointer;
    padding: 5px 20px;
    margin: 0px 0px 0px auto;
    border-radius: 5px;
    background-color: var(--blue-60);
}

/* COMMENT CONTAINER END */

/* HELP CONTAINER */

.help-container {
    max-width: 300px;
    border-radius: 10px 0px 0px 10px;
    margin: 0px 10px 10px 10px;
    border: 1px solid var(--border);
    overflow-y: scroll;

    /* TEXT STYLE */
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    line-height: 150%;
}

.help-title {
    margin: 10px;

    font-size: 24px;
    font-weight: 600;
}

.help-content {
    margin: 10px;

}

.help-subtitle {
    margin-top: 20px;
    font-weight: 600;
}

/* HELP CONTAINER END */



/* NAVIGATION CONTAINER */

.navigation-whole {
    position: relative;
    display: flex;
    height: 82px;
    flex-direction: row;
    justify-content: center;
}

.navigation-opener-container-down {
    position: absolute;
    top: -20px;
    left: 50%;
    /* Set left to 50% to center horizontally */
    transform: translateX(-50%) translateY(65px);
    /* Adjust for the width of the container */
    width: 50px;
    height: 20px;
    /* Adjust the height as needed */
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px 10px 0px 0px;
    background-color: var(--gray-20);
}

.navigation-opener-container-up {
    position: absolute;
    top: -20px;
    left: 50%;
    /* Set left to 50% to center horizontally */
    transform: translateX(-50%);
    /* Adjust for the width of the container */
    width: 50px;
    height: 20px;
    /* Adjust the height as needed */
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px 10px 0px 0px;
    background-color: var(--gray-20);
}

.navigation-img-down {
    align-self: center;
    justify-content: center;
    transform: rotate(0deg);
    width: 30px;
    height: 30px;
}

.navigation-img-up {
    align-self: center;
    justify-content: center;
    transform: rotate(180deg);
    width: 30px;
    height: 30px;
}


.navigation-container {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    background-color: var(--gray-20);
}

.navigation-inner-container {
    position: relative;
    display: flex;
    height: 95%;
    margin: 3px 3px 0px 3px;
    overflow-x: auto;
    gap: 0px;
}

.navigation-item-container {
    position: relative;
    display: flex;
    flex-direction: row;
    max-width: 45px;
    max-height: 45px;
    margin: 2px;
    border-radius: 5px;
    background-color: var(--gray-40);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    cursor: pointer;
}

.nav-item-selected {
    background-color: var(--blue-60);
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
}

.nav-item-filled {
    background-color: var(--blue-40);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2)
}

.navigation-item {
    position: relative;
    justify-content: center;
    align-self: center;
    display: flex;
    width: 24px;
    max-width: 24px;
    height: 24px;
    max-height: 24px;
    color: var(--white-base);
    margin: 10px;
    -webkit-user-select: none;
            user-select: none;

    /* TEXT STYLE */
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
}

/* NAVIGATION CONTAINER END */





/* TREEFRAGEN WIDGET START */

.treefrage-title-header-container {
    margin: 10px 40px;
    overflow-y: hidden;
}

.treefragen-button {
    position: relative;
    background-color: var(--blue-50);
    color: white;
    padding: 10px 20px;
    width: fit-content;
    border-radius: 5px;
    cursor: pointer;
    border: none;
    margin-right: 0px;
    margin-left: 0px;
    font-weight: 600;
    font-size: 20px;
    transition: all 0.3s;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);

    /* TEXT STYLE */
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
}

.treefragen-button:hover {
    transform: translateY(-3px);
    /* Move the button up slightly on hover */
    background-color: var(--blue-60);
    /* Lighter background color on hover */
}

.treefragen-button:focus {
    outline: none;
    /* Remove focus outline */
}

.treefragen-button:active {
    transform: translateY(1px);
    /* Push the button down slightly when clicked */
    box-shadow: none;
    /* Remove box shadow when clicked */
}


.treefragen-button-cancel {
    background-color: var(--dark-theme-gray-4);
}

.treefragen-button-save {
    margin-left: auto;
    float: right;
}


/* TREEFRAGEN WIDGET END */`, "",{"version":3,"sources":["webpack://./src/widgets/FragebogenWidget.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,8BAA8B;IAC9B,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,kBAAkB;;IAElB,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;AACf;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,SAAS;AACb;;;AAGA;IACI,kBAAkB;;;IAGlB,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;;AAGA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;;;IAGZ,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,2BAA2B;;IAE3B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;;AAGA;IACI;MACE,QAAQ;IACV;EACF;;;AAGF;IACI,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,yBAAiB;YAAjB,iBAAiB;IACjB,+BAA+B;;IAE/B,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;;;;AAKA,wBAAwB;;;AAGxB,oBAAoB;;AAEpB;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;;;IAGhB,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,SAAS;IACT,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,SAAS;IACT,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;IAC9B,qBAAqB;;IAErB,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,yBAAiB;YAAjB,iBAAiB;;IAEjB,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;;AAGA,iCAAiC;AACjC;IACI,aAAa;IACb,iCAAiC;AACrC;;AAEA,kDAAkD;AAClD;IACI,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,uEAAuE;IACvE,kBAAkB;IAClB,oEAAoE;IACpE,eAAe;AACnB;;AAEA,wDAAwD;AACxD;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA,oDAAoD;AACpD;IACI,gCAAgC;IAChC,YAAY;IACZ,oDAAoD;IACpD,4BAA4B;AAChC;;AAEA,wBAAwB;;;;AAIxB,qBAAqB;;AAErB;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,mCAAmC;IACnC,iBAAiB;IACjB,yBAAiB;YAAjB,iBAAiB;;IAEjB,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;;AAGA;IACI,eAAe;IACf,kBAAkB;AACtB;;;AAGA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,yBAAyB;IACzB,iCAAiC;IACjC,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;;IAEjB,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA,yBAAyB;;;;AAIzB,sBAAsB;;AAEtB;IACI,eAAe;IACf,WAAW;IACX,cAAc;IACd,4EAA4E;IAC5E,WAAW;IACX,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,UAAU;IACV,6DAA6D;IAC7D,UAAU;IACV,+BAA+B;IAC/B,mDAAmD;AACvD;;AAEA;IACI;QACI,UAAU;QACV,6CAA6C;QAC7C,iCAAiC;IACrC;;IAEA;QACI,UAAU;QACV,0CAA0C;IAC9C;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mDAAmD;IACnD,sBAAsB;IACtB,qEAAqE;AACzE;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,eAAe;IACf,eAAe;;IAEf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;;IAEX,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA,0BAA0B;;AAE1B,mBAAmB;;AAEnB;IACI,gBAAgB;IAChB,gCAAgC;IAChC,0BAA0B;IAC1B,+BAA+B;IAC/B,kBAAkB;;IAElB,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,YAAY;;IAEZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;;AAEhB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,uBAAuB;;;;AAIvB,yBAAyB;;AAEzB;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,2CAA2C;IAC3C,4CAA4C;IAC5C,0CAA0C;IAC1C,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,2CAA2C;IAC3C,2BAA2B;IAC3B,0CAA0C;IAC1C,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB;IACzB,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,8CAA8C;AAClD;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;IACxB,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;;IAEjB,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,6BAA6B;;;;;;AAM7B,4BAA4B;;AAE5B;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,0CAA0C;;IAE1C,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;IACzC,gCAAgC;IAChC,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,+CAA+C;IAC/C,gBAAgB;IAChB,mCAAmC;AACvC;;;AAGA;IACI,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;;AAGA,0BAA0B","sourcesContent":["/* MODAL CONTAINER */\r\n\r\n.fragen-background {\r\n    position: fixed;\r\n    top: 80px;\r\n    left: 0;\r\n    align-self: center;\r\n    width: 100%;\r\n    height: calc(100% - 80px);\r\n    background: rgba(0, 0, 0, 0.5);\r\n    z-index: 999;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.fragen-content-container {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-self: center;\r\n    width: 80%;\r\n    height: 95%;\r\n    background-color: var(--white-base);\r\n    border-radius: 20px;\r\n}\r\n\r\n.fragen-closebutton {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    top: 10px;\r\n    right: 10px;\r\n    width: 30px;\r\n    height: 30px;\r\n    border-radius: 50%;\r\n}\r\n\r\n.fragen-header-container {\r\n    position: relative;\r\n    margin: 30px 50px 20px 10px;\r\n    align-self: center;\r\n\r\n    /* TEXT STYLE */\r\n    font-family: Poppins;\r\n    font-size: 30px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n}\r\n\r\n.fragen-header-gruppenassessment {\r\n    color: var(--vzk-blue);\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n}\r\n\r\n.fragen-main-content-split {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: row;\r\n    width: 100%;\r\n    height: 100%;\r\n    overflow: hidden;\r\n}\r\n\r\n.fragen-main-content {\r\n    position: relative;\r\n    display: flex;\r\n    margin: 10px;\r\n    height: 100%;\r\n    width: 97%;\r\n    justify-content: center;\r\n    align-self: center;\r\n    align-items: center;\r\n}\r\n\r\n.fragen-main-inner-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n\r\n.fragen-page-container {\r\n    position: relative;\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100vh;\r\n    margin: 10px;\r\n    gap: 20px;\r\n}\r\n\r\n\r\n.fragen-page-title {\r\n    position: relative;\r\n\r\n\r\n    /* TEXT STYLE */\r\n    font-family: Poppins;\r\n    font-size: 24px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 150%;\r\n}\r\n\r\n\r\n.fragen-page-end-title {\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100%;\r\n\r\n\r\n    /* TEXT STYLE */\r\n    font-family: Poppins;\r\n    font-size: 24px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 150%;\r\n}\r\n\r\n.fragen-page-img {\r\n    display: flex;\r\n    justify-content: top;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 20px;\r\n}\r\n\r\n.fragen-page-disclaimer {\r\n    color: var(--blue-grey-500);\r\n\r\n    font-family: Poppins;\r\n    font-size: 15px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 150%;\r\n}\r\n\r\n.fragen-page-img img {\r\n    max-width: 60%;\r\n    height: auto;\r\n}\r\n\r\n.fragen-page-button-container {\r\n    position: relative;\r\n    top: 100%;\r\n    bottom: 0px;\r\n    display: flex;\r\n    width: 100%;\r\n    flex-direction: row;\r\n}\r\n\r\n\r\n@media (max-height: 3000px) {\r\n    .fragen-page-button-container {\r\n      top: 10%;\r\n    }\r\n  }\r\n\r\n\r\n.fragen-end-container {\r\n    margin-top: 50px;\r\n    margin-right: 20px;\r\n    gap: 50px;\r\n}\r\n\r\n.fragen-page-button {\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-self: center;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    cursor: pointer;\r\n    border-radius: 20px;\r\n    padding: 0px 15px;\r\n    user-select: none;\r\n    background-color: var(--border);\r\n\r\n    /* TEXT STYLE */\r\n    font-family: Poppins;\r\n    font-size: 20px;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    line-height: 150%;\r\n}\r\n\r\n\r\n\r\n\r\n/* MODAL CONTAINER END */\r\n\r\n\r\n/* FRAGE CONTAINER */\r\n\r\n.frage-title-header-container {\r\n    margin: 10px 40px;\r\n    overflow-y: auto;\r\n}\r\n\r\n.frage-title-container {\r\n    position: relative;\r\n    height: fit-content;\r\n}\r\n\r\n.frage-title-header {\r\n    font-family: Poppins;\r\n    font-size: 20px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 100%;\r\n}\r\n\r\n.frage-container {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: fit-content;\r\n    height: fit-content;\r\n    min-height: 80px;\r\n\r\n\r\n    /* TEXT STYLE */\r\n    font-family: Poppins;\r\n    font-size: 20px;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    line-height: 125%;\r\n}\r\n\r\n.frage-beispiel {\r\n    color: var(--blue-grey-500);\r\n    /* Body */\r\n    font-family: Poppins;\r\n    font-size: 13px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 150%;\r\n}\r\n\r\n.frage-kategorie {\r\n    color: var(--vzk-blue);\r\n    /* Body */\r\n    font-family: Poppins;\r\n    font-size: 16px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 150%;\r\n}\r\n\r\n.antwort-container {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin-top: 0px;\r\n    margin-bottom: 0px;\r\n    gap: 0px;\r\n}\r\n\r\n.antonwort-item-container {\r\n    position: relative;\r\n    display: flex;\r\n    min-height: 75px;\r\n    height: fit-content;\r\n    /*84px;*/\r\n    overflow-y: auto;\r\n    padding: 10px;\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n    align-items: top;\r\n}\r\n\r\n.antonwort-item-beispiel {\r\n    position: relative;\r\n    margin-top: auto;\r\n    margin-left: 50px;\r\n    margin-bottom: 0px;\r\n    text-align: left;\r\n    /* Changed to left alignment */\r\n    color: var(--gray-50);\r\n\r\n    /* TEXT STYLE */\r\n    font-family: Poppins;\r\n    font-size: 14px;\r\n    font-style: italic;\r\n    font-weight: 400;\r\n}\r\n\r\n.antwort-level {\r\n    margin-left: 10px;\r\n    user-select: none;\r\n\r\n    /* TEXT STYLE */\r\n    font-family: Poppins;\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n}\r\n\r\n\r\n/* Styles for the radio buttons */\r\n.antonwort-item-container input[type=\"radio\"] {\r\n    display: none;\r\n    /* Hide the actual radio button */\r\n}\r\n\r\n/* Styles for the custom radio button appearance */\r\n.antonwort-item-container input[type=\"radio\"]+label {\r\n    position: relative;\r\n    display: inline-block;\r\n    padding-left: 25px;\r\n    /* Adjust spacing between the custom radio button and label if needed */\r\n    padding-right: 8px;\r\n    /* Adjust the space between the custom radio button and label text */\r\n    cursor: pointer;\r\n}\r\n\r\n/* Styles for the custom radio button when not checked */\r\n.antonwort-item-container input[type=\"radio\"]+label:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 30%;\r\n    left: 0;\r\n    width: 16px;\r\n    height: 16px;\r\n    border: 2px solid var(--border);\r\n    border-radius: 3px;\r\n    background-color: #fff;\r\n    transform: translateX(-10px);\r\n}\r\n\r\n/* Styles for the custom radio button when checked */\r\n.antonwort-item-container input[type=\"radio\"]:checked+label:before {\r\n    background-color: var(--blue-60);\r\n    border: none;\r\n    box-shadow: 0 0 0 2px #fff, 0 0 0 4px var(--blue-60);\r\n    transform: translateX(-10px);\r\n}\r\n\r\n/* FRAGE CONTAINER END */\r\n\r\n\r\n\r\n/* FOOTER CONTAINER */\r\n\r\n.footer-container {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.footer-item-container {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: row;\r\n    border-radius: 0px 0px 18px 18px;\r\n    background-color: var(--gray-40);\r\n    min-height: 50px;\r\n}\r\n\r\n.footer-item {\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-self: center;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    cursor: pointer;\r\n    border-radius: 20px;\r\n    background-color: var(--white-base);\r\n    padding: 0px 15px;\r\n    user-select: none;\r\n\r\n    /* TEXT STYLE */\r\n    font-family: Poppins;\r\n    font-size: 20px;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    line-height: 150%;\r\n}\r\n\r\n.item-left {\r\n    margin: 0px 10px 0px auto;\r\n    border-radius: 20px 5px 5px 20px;\r\n}\r\n\r\n\r\n.item-pause {\r\n    margin: 0px 0px;\r\n    border-radius: 5px;\r\n}\r\n\r\n\r\n.item-right {\r\n    margin: 0px auto 0px 10px;\r\n    border-radius: 5px 20px 20px 5px;\r\n}\r\n\r\n.item-comment-aktive {\r\n    margin: 0px 10px 0px auto;\r\n    border-radius: 20px 20px 0px 20px;\r\n}\r\n\r\n.item-comment-disabled {\r\n    background-color: var(--gray-50);\r\n    color: var(--gray-20);\r\n    margin: 0px 10px 0px auto;\r\n    border-radius: 20px 20px 0px 20px;\r\n    pointer-events: none;\r\n}\r\n\r\n.item-help {\r\n    margin: 0px auto 0px 10px;\r\n}\r\n\r\n.item-bezugsdatum-festlegen {\r\n    border: none;\r\n    margin: 0px;\r\n}\r\n\r\n.item-save {\r\n    margin: 0px auto 0px auto;\r\n}\r\n\r\n.footer-item-text {\r\n    position: relative;\r\n    display: flex;\r\n    align-self: center;\r\n    margin-left: auto;\r\n    margin-right: 10px;\r\n    user-select: none;\r\n\r\n    /* TEXT STYLE */\r\n    font-family: Poppins;\r\n    font-size: 20px;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    line-height: 150%;\r\n}\r\n\r\n.button-disabled{    \r\n    background-color: var(--gray-50);\r\n    color: var(--gray-20);\r\n    pointer-events: none;\r\n}\r\n\r\n/* FOOTER CONTAINER END */\r\n\r\n\r\n\r\n/* COMMENT CONTAINER */\r\n\r\n.comment-container {\r\n    position: fixed;\r\n    width: 100%;\r\n    max-width: 70%;\r\n    /* Adjust the value based on your margin for .frage-title-header-container */\r\n    height: 16%;\r\n    bottom: 60px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    background-color: #fff;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);\r\n    z-index: 2;\r\n    /* Ensure the Kommentar widget appears above other elements */\r\n    opacity: 0;\r\n    animation: fadeIn 0.5s forwards;\r\n    /* Apply fadeIn animation when initially rendered */\r\n}\r\n\r\n@keyframes fadeIn {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateX(-50%), translateY(20px);\r\n        /* Adjust the starting position */\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform: translateX(-50%), translateY(0);\r\n    }\r\n}\r\n\r\n.comment-closebutton {\r\n    position: absolute;\r\n    z-index: 99;\r\n    top: 10px;\r\n    right: 10px;\r\n    width: 30px;\r\n    height: 30px;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n}\r\n\r\n.comment-title {\r\n    position: relative;\r\n    font-family: Poppins;\r\n    font-size: 20px;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    line-height: 150%;\r\n}\r\n\r\n.comment-content {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n    max-height: 60%;\r\n    /* Set max-height to 100% of the parent container */\r\n    box-sizing: border-box;\r\n    /* Include padding and borders in the height and width calculations */\r\n}\r\n\r\n.comment-textarea {\r\n    position: relative;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n    width: 100%;\r\n    height: 70%;\r\n    max-width: 100%;\r\n    max-height: 90%;\r\n\r\n    font-size: 16px;\r\n    line-height: 1.5;\r\n}\r\n\r\n.comment-button-section {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: row;\r\n    height: fit-content;\r\n    height: 30%;\r\n\r\n    /* TEXT STYLE */\r\n    font-family: Poppins;\r\n    font-size: 16px;\r\n    font-style: normal;\r\n    line-height: 150%;\r\n    color: white;\r\n}\r\n\r\n.commen-button-l {\r\n    position: relative;\r\n    height: fit-content;\r\n    width: fit-content;\r\n    cursor: pointer;\r\n    padding: 5px 20px;\r\n    margin: 0px auto 0px 0px;\r\n    border-radius: 5px;\r\n    background-color: var(--blue-60);\r\n}\r\n\r\n.commen-button-r {\r\n    position: relative;\r\n    height: fit-content;\r\n    width: fit-content;\r\n    cursor: pointer;\r\n    padding: 5px 20px;\r\n    margin: 0px 0px 0px auto;\r\n    border-radius: 5px;\r\n    background-color: var(--blue-60);\r\n}\r\n\r\n/* COMMENT CONTAINER END */\r\n\r\n/* HELP CONTAINER */\r\n\r\n.help-container {\r\n    max-width: 300px;\r\n    border-radius: 10px 0px 0px 10px;\r\n    margin: 0px 10px 10px 10px;\r\n    border: 1px solid var(--border);\r\n    overflow-y: scroll;\r\n\r\n    /* TEXT STYLE */\r\n    font-family: Poppins;\r\n    font-size: 16px;\r\n    font-style: normal;\r\n    line-height: 150%;\r\n}\r\n\r\n.help-title {\r\n    margin: 10px;\r\n\r\n    font-size: 24px;\r\n    font-weight: 600;\r\n}\r\n\r\n.help-content {\r\n    margin: 10px;\r\n\r\n}\r\n\r\n.help-subtitle {\r\n    margin-top: 20px;\r\n    font-weight: 600;\r\n}\r\n\r\n/* HELP CONTAINER END */\r\n\r\n\r\n\r\n/* NAVIGATION CONTAINER */\r\n\r\n.navigation-whole {\r\n    position: relative;\r\n    display: flex;\r\n    height: 82px;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n}\r\n\r\n.navigation-opener-container-down {\r\n    position: absolute;\r\n    top: -20px;\r\n    left: 50%;\r\n    /* Set left to 50% to center horizontally */\r\n    transform: translateX(-50%) translateY(65px);\r\n    /* Adjust for the width of the container */\r\n    width: 50px;\r\n    height: 20px;\r\n    /* Adjust the height as needed */\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 10px 10px 0px 0px;\r\n    background-color: var(--gray-20);\r\n}\r\n\r\n.navigation-opener-container-up {\r\n    position: absolute;\r\n    top: -20px;\r\n    left: 50%;\r\n    /* Set left to 50% to center horizontally */\r\n    transform: translateX(-50%);\r\n    /* Adjust for the width of the container */\r\n    width: 50px;\r\n    height: 20px;\r\n    /* Adjust the height as needed */\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 10px 10px 0px 0px;\r\n    background-color: var(--gray-20);\r\n}\r\n\r\n.navigation-img-down {\r\n    align-self: center;\r\n    justify-content: center;\r\n    transform: rotate(0deg);\r\n    width: 30px;\r\n    height: 30px;\r\n}\r\n\r\n.navigation-img-up {\r\n    align-self: center;\r\n    justify-content: center;\r\n    transform: rotate(180deg);\r\n    width: 30px;\r\n    height: 30px;\r\n}\r\n\r\n\r\n.navigation-container {\r\n    position: relative;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: var(--gray-20);\r\n}\r\n\r\n.navigation-inner-container {\r\n    position: relative;\r\n    display: flex;\r\n    height: 95%;\r\n    margin: 3px 3px 0px 3px;\r\n    overflow-x: auto;\r\n    gap: 0px;\r\n}\r\n\r\n.navigation-item-container {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: row;\r\n    max-width: 45px;\r\n    max-height: 45px;\r\n    margin: 2px;\r\n    border-radius: 5px;\r\n    background-color: var(--gray-40);\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n    cursor: pointer;\r\n}\r\n\r\n.nav-item-selected {\r\n    background-color: var(--blue-60);\r\n    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.nav-item-filled {\r\n    background-color: var(--blue-40);\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2)\r\n}\r\n\r\n.navigation-item {\r\n    position: relative;\r\n    justify-content: center;\r\n    align-self: center;\r\n    display: flex;\r\n    width: 24px;\r\n    max-width: 24px;\r\n    height: 24px;\r\n    max-height: 24px;\r\n    color: var(--white-base);\r\n    margin: 10px;\r\n    user-select: none;\r\n\r\n    /* TEXT STYLE */\r\n    font-family: Poppins;\r\n    font-size: 18px;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    line-height: 150%;\r\n}\r\n\r\n/* NAVIGATION CONTAINER END */\r\n\r\n\r\n\r\n\r\n\r\n/* TREEFRAGEN WIDGET START */\r\n\r\n.treefrage-title-header-container {\r\n    margin: 10px 40px;\r\n    overflow-y: hidden;\r\n}\r\n\r\n.treefragen-button {\r\n    position: relative;\r\n    background-color: var(--blue-50);\r\n    color: white;\r\n    padding: 10px 20px;\r\n    width: fit-content;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    border: none;\r\n    margin-right: 0px;\r\n    margin-left: 0px;\r\n    font-weight: 600;\r\n    font-size: 20px;\r\n    transition: all 0.3s;\r\n    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);\r\n\r\n    /* TEXT STYLE */\r\n    font-family: Poppins;\r\n    font-size: 18px;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    line-height: 150%;\r\n}\r\n\r\n.treefragen-button:hover {\r\n    transform: translateY(-3px);\r\n    /* Move the button up slightly on hover */\r\n    background-color: var(--blue-60);\r\n    /* Lighter background color on hover */\r\n}\r\n\r\n.treefragen-button:focus {\r\n    outline: none;\r\n    /* Remove focus outline */\r\n}\r\n\r\n.treefragen-button:active {\r\n    transform: translateY(1px);\r\n    /* Push the button down slightly when clicked */\r\n    box-shadow: none;\r\n    /* Remove box shadow when clicked */\r\n}\r\n\r\n\r\n.treefragen-button-cancel {\r\n    background-color: var(--dark-theme-gray-4);\r\n}\r\n\r\n.treefragen-button-save {\r\n    margin-left: auto;\r\n    float: right;\r\n}\r\n\r\n\r\n/* TREEFRAGEN WIDGET END */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
